import React, { useState, useRef, useEffect, useCallback } from "react";
import * as APIModels from "../../../../models";
import Select, { ActionMeta } from "react-select";
import AsyncSelect from "react-select/async";
import { SubmissionService } from "../../../../services/SubmissionService";
import CaseDataInput from "../CaseDataInput";
import Parties from "../Parties";
import Pleadings from "../Pleadings";
import Fees from "../Fees";
import TylerPleadings from "../TylerPleadings";

type MyOptionType = { label: string; value: string };

export default function NewCase({
    submission,
    onSelectDocument,
    filter,
    currentDocument,
}: {
    submission: APIModels.Submission;
    onSelectDocument: (doc: APIModels.Document, index: number) => void;
    filter?: string;
    currentDocument: APIModels.Document | null;
}) {
    const [completedSubmission, setCompletedSubmission] = useState(submission);
    const [completedDocs, setCompletedDocs] = useState(submission.documents!);
    const [completedFees, setCompletedFees] = useState(submission.fees ?? []);
    const [completedParties, setCompletedParties] = useState(
        submission.parties ?? []
    );
    const [submitting, setSubmitting] = useState(false);
    const [feeLoading, setFeeLoading] = useState(true);
    const partiesTab = React.createRef<HTMLButtonElement>();
    const [override, setOverride] = useState(false);
    const [selectedDocument, setSelectedDocument] = useState(currentDocument);

    useEffect(() => {
        setSelectedDocument(currentDocument);
    }, [currentDocument]);

    useEffect(() => console.log(completedSubmission), [completedSubmission]);

    // f4 to submit
    useEffect(() => {
        const handelKeyboardSubmit = (e: KeyboardEvent) => {
            if (e.key === "F4") {
                onSubmit();
            }
        };

        window.addEventListener("keydown", handelKeyboardSubmit);
        return window.removeEventListener("keydown", handelKeyboardSubmit);
    }, []);

    const onSaveCaseData = (
        caseData: APIModels.CaseData,
        portalIdentifier: string
    ) => {
        console.log(`The division is ${caseData.division} in Parent`);
        setCompletedSubmission({
            ...completedSubmission,
            caseData: caseData,
            portalIdentifier: portalIdentifier,
        });

        if (caseData.caseSubTypeID && caseData.caseTypeID) {
            partiesTab?.current?.click();
        }
    };

    const onUpdateParties = (parties: APIModels.Party[]) => {
        setCompletedParties(parties);
    };

    const handleFeeLoading = (value: boolean) => {
        console.log({ "Handeling fees loading: ": !feeLoading });
        setFeeLoading(value);
    };

    const onUpdateDoc = (doc: APIModels.Document) => {
        const docs = [...completedDocs!];
        const index = completedDocs?.findIndex((v) => v.id == doc.id);
        // console.log("onUpdateDoc in NewCase " + JSON.stringify(docs[index!]));
        docs[index!].documentType = doc.documentType;
        docs[index!].documentTypeID = doc.documentTypeID;
        docs[index!].filingCodeID = doc.filingCodeID;
        docs[index!].filingComponentID = doc.filingComponentID;
        docs[index!].securityID = doc.securityID;
        docs[index!].description = doc.description;
        docs[index!].fees = doc.fees;
        docs[index!].optionalServices = doc.optionalServices;
        setCompletedDocs(docs);
    };

    const onFeeChange = (fees: APIModels.FeeType[]) => {
        setCompletedFees(fees);
    };

    // add a callback function for the loading button.

    const onTestSubmit = () => {
        console.log(completedSubmission);
    };

    const onSubmit = () => {
        setSubmitting(true);
        SubmissionService.submit({
            attorneyId: completedSubmission.attorneyID,
            filter: filter,
            state: submission.portalIdentifier,
            body: {
                ...completedSubmission,
                documents: completedDocs,
                fees: completedFees,
                parties: completedParties,
                override: override,
            },
        }).then(
            (resp) => {
                console.log(resp);
                if (resp.data && resp.data.id) {
                    //show efile success
                    //setNextSubmission(resp.data);
                    window.location.href = `/efile?submissionId=${resp.data.id}&filter=${filter}`;
                } else {
                    //TODO: Show error
                    window.location.href = "/queue";
                }
            },
            (error) => {
                setSubmitting(false);
                window.location.href = "/queue";
            }
        );
    };

    return (
        <>
            <div
                className="accordion accordion-flush"
                id="accordionFlushExample"
            >
                <div className="accordion-item">
                    <h2 className="accordion-header" id="flush-headingOne">
                        <button
                            className="accordion-button"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#flush-collapseOne"
                            aria-expanded="true"
                            aria-controls="flush-collapseOne"
                        >
                            Case Information
                        </button>
                    </h2>
                    <div
                        id="flush-collapseOne"
                        className="accordion-collapse collapse show"
                        aria-labelledby="flush-headingOne"
                        data-bs-parent="#accordionFlushExample"
                    >
                        <div className="accordion-body">
                            <CaseDataInput
                                submission={completedSubmission}
                                onSaveCaseData={onSaveCaseData}
                            />
                        </div>
                    </div>
                </div>
                <div className="accordion-item">
                    <h2 className="accordion-header" id="flush-headingTwo">
                        <button
                            ref={partiesTab}
                            className="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#flush-collapseTwo"
                            aria-expanded="false"
                            aria-controls="flush-collapseTwo"
                            disabled={
                                !submission.caseData?.caseTypeID &&
                                !submission.caseData?.caseSubTypeID
                            }
                        >
                            Parties
                        </button>
                    </h2>
                    <div
                        id="flush-collapseTwo"
                        className="accordion-collapse collapse"
                        aria-labelledby="flush-headingTwo"
                        data-bs-parent="#accordionFlushExample"
                    >
                        <div className="accordion-body">
                            <Parties
                                submission={completedSubmission}
                                parties={completedParties}
                                onUpdateParties={onUpdateParties}
                                currentDocument={selectedDocument}
                            />
                        </div>
                    </div>
                </div>
                <div className="accordion-item">
                    <h2 className="accordion-header" id="flush-headingThree">
                        <button
                            className="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#flush-collapseThree"
                            aria-expanded="false"
                            aria-controls="flush-collapseThree"
                        >
                            Documents
                        </button>
                    </h2>
                    <div
                        id="flush-collapseThree"
                        className="accordion-collapse collapse"
                        aria-labelledby="flush-headingThree"
                        data-bs-parent="#accordionFlushExample"
                    >
                        <div className="accordion-body">
                            {submission.portalIdentifier == "TX" ||
                            submission.portalIdentifier == "IL" ||
                            submission.portalIdentifier == "NC" ||
                            submission.portalIdentifier == "CA" ||
                            (submission.portalIdentifier == "GA" &&
                                completedSubmission.caseData &&
                                completedSubmission.caseData.caseSubTypeID ===
                                    APIModels.EmptyGuid) ||
                            submission.portalIdentifier == "MD" ||
                            submission.portalIdentifier == "IN" ||
                            completedSubmission.portalIdentifier == "GO" ? (
                                //completedSubmission.portalIdentifier == "GO"
                                <TylerPleadings
                                    submission={completedSubmission}
                                    originalDocs={completedDocs}
                                    onSelectDocument={onSelectDocument}
                                    onUpdateDoc={onUpdateDoc}
                                />
                            ) : (
                                <Pleadings
                                    submission={completedSubmission}
                                    originalDocs={completedDocs}
                                    onSelectDocument={onSelectDocument}
                                    onUpdateDoc={onUpdateDoc}
                                />
                            )}
                        </div>
                    </div>
                </div>

                <div className="accordion-body">
                    {submission.portalIdentifier == "TX" ||
                    submission.portalIdentifier == "IL" ||
                    (submission.portalIdentifier == "GA" &&
                        completedSubmission.caseData &&
                        completedSubmission.caseData.caseSubTypeID ===
                            APIModels.EmptyGuid) ||
                    submission.portalIdentifier == "MD" ||
                    submission.portalIdentifier == "IN" ||
                    completedSubmission.portalIdentifier == "GO" ? (
                        //completedSubmission.portalIdentifier == "GO"
                        <></>
                    ) : (
                        <div className="accordion-item">
                            <h2
                                className="accordion-header"
                                id="flush-headingFour"
                            >
                                <button
                                    className="accordion-button collapsed"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#flush-collapseFour"
                                    aria-expanded="false"
                                    aria-controls="flush-collapseFour"
                                >
                                    Fees &nbsp;
                                    {feeLoading ? (
                                        <span
                                            className="spinner-border spinner-border-sm me-1"
                                            role="status"
                                            aria-hidden="true"
                                        ></span>
                                    ) : (
                                        <></>
                                    )}
                                </button>
                            </h2>
                            <div
                                id="flush-collapseFour"
                                className="accordion-collapse collapse"
                                aria-labelledby="flush-headingFour"
                                data-bs-parent="#accordionFlushExample"
                            >
                                <div className="accordion-body">
                                    <Fees
                                        submission={completedSubmission}
                                        fees={completedFees}
                                        handleFeeLoading={handleFeeLoading}
                                        onFeeChange={onFeeChange}
                                    />
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
            <div className="row">
                <div className="col-12" style={{ textAlign: "center" }}>
                    {submitting ? ( // if the component is loading or the document is submitting.
                        <button
                            className="btn btn-primary"
                            type="button"
                            disabled={true}
                        >
                            <span
                                className="spinner-border spinner-border-sm me-1"
                                role="status"
                                aria-hidden="true"
                            ></span>
                            Submitting...
                        </button>
                    ) : feeLoading &&
                      !(
                          submission.portalIdentifier == "TX" ||
                          submission.portalIdentifier == "IL" ||
                          (submission.portalIdentifier == "GA" &&
                              completedSubmission.caseData &&
                              completedSubmission.caseData.caseSubTypeID ===
                                  APIModels.EmptyGuid) ||
                          submission.portalIdentifier == "MD" ||
                          submission.portalIdentifier == "IN" ||
                          completedSubmission.portalIdentifier == "GO"
                      ) ? (
                        // if the component is loading or the document is submitting.
                        <button
                            className="btn btn-primary"
                            type="button"
                            disabled={true}
                        >
                            Submit
                        </button>
                    ) : (
                        <button
                            className="btn btn-primary"
                            type="button"
                            onClick={onSubmit}
                        >
                            Submit
                        </button>
                    )}
                </div>
            </div>
            <div className="row mt-2">
                <div
                    className="col-12"
                    style={{
                        display: "flex",
                        justifyContent: "center",
                    }}
                >
                    <div
                        className="col-2"
                        style={{
                            display: "flex",
                            justifyContent: "center",
                        }}
                    >
                        <div className="form-check">
                            <input
                                className="form-check-input"
                                id="ckOverride"
                                type="checkbox"
                                checked={override ?? false}
                                onChange={(event) =>
                                    setOverride(event.currentTarget.checked)
                                }
                            />
                            <label
                                className="form-check-label"
                                htmlFor="ckOverride"
                            >
                                Override
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
